import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '@api/client';
import { useAuthStore } from '@store/authStore';
import { useNotificationStore } from '@store/notificationStore';

interface LogoutResponse {
  message: string;
}

export const useLogout = () => {
  const navigate = useNavigate();
  const { clearAuth } = useAuthStore();
  const { addNotification } = useNotificationStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.post<LogoutResponse>('/auth/logout');
      return data;
    },
    onSuccess: () => {
      // Clear auth state
      clearAuth();

      // Clear all queries
      queryClient.clear();

      // Show notification
      addNotification({
        message: 'You have been logged out successfully',
        type: 'success',
      });

      // Redirect to auth page
      navigate('/auth', { replace: true });
    },
    onError: (error: any) => {
      // Even if logout fails, clear local auth state
      clearAuth();
      queryClient.clear();

      const errorMessage =
        error.response?.data?.detail ||
        error.message ||
        'Logout failed. Please try again.';

      addNotification({
        message: errorMessage,
        type: 'error',
      });

      navigate('/auth', { replace: true });
    },
  });
};
